import { useState, useCallback, useEffect } from "react";

import { useSelector } from "react-redux";
import { REQUESTS } from "Util/constants";

import FormTextInput from "../../../../../../Components/FormInput/index";

import "./LoginForm.css";

const LOGIN_FORM_LABELS = {
  EMAIL: "Email",
  PASSWORD: "Password",
};
const LoginForm = (props) => {
  const { onForgotPasswordClick, onLogin } = props;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginErrorMessage, setLoginErrorMessage] = useState('')

  const loginError = useSelector(
    (state) =>
      state.stateSlice?.requestErrorMessages[REQUESTS.EMAIL_PASSWORD_LOGIN]
  );
  useEffect(() => {
    if (loginError) {
        setLoginErrorMessage(loginError);
        setTimeout(() => setLoginErrorMessage(''), 2000)
    }
  }, [loginError])
  const handleEmailChange = useCallback((e) => setEmail(e.target.value), []);

  const handlePasswordChange = useCallback(
    (e) => setPassword(e.target.value),
    []
  );

  const handleSubmitLoginRequest = useCallback(() => {
    onLogin(email, password);
  }, [email, password, onLogin]);

  return (
    <div className="login-form-container">
      <h4>Login</h4>
      {loginErrorMessage ? (
        <div className="login-error-text-continer">{loginErrorMessage}</div>
      ) : null}
      <div className="login-form-inputs-container">
        <FormTextInput
          inputLabel={LOGIN_FORM_LABELS.EMAIL}
          onChange={handleEmailChange}
          value={email}
        />
        <FormTextInput
          inputLabel={LOGIN_FORM_LABELS.PASSWORD}
          onChange={handlePasswordChange}
          value={password}
          labelButtonText="Forgot Password?"
          onClickLabelButton={onForgotPasswordClick}
          inputType={LOGIN_FORM_LABELS.PASSWORD}
        />
      </div>

      <div className="login-button" name='login-button' onClick={handleSubmitLoginRequest}>
        Login
      </div>
    </div>
  );
};

export default LoginForm;
